/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Invite_Success_RequestInputs */

const en_community_invite_success_request = /** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access request sent to the owner!`)
};

const id_community_invite_success_request = /** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan akses telah dikirim ke pemilik!`)
};

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const es_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const fr_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const de_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const ja_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const zh_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const ar_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const it_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const ru_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const pt_community_invite_success_request = en_community_invite_success_request;

/** @type {(inputs: Community_Invite_Success_RequestInputs) => LocalizedString} */
const ko_community_invite_success_request = en_community_invite_success_request;

/**
* | output |
* | --- |
* | "Access request sent to the owner!" |
*
* @param {Community_Invite_Success_RequestInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const community_invite_success_request = /** @type {((inputs?: Community_Invite_Success_RequestInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Invite_Success_RequestInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_community_invite_success_request(inputs)
	if (locale === "es") return es_community_invite_success_request(inputs)
	if (locale === "fr") return fr_community_invite_success_request(inputs)
	if (locale === "de") return de_community_invite_success_request(inputs)
	if (locale === "ja") return ja_community_invite_success_request(inputs)
	if (locale === "zh") return zh_community_invite_success_request(inputs)
	if (locale === "ar") return ar_community_invite_success_request(inputs)
	if (locale === "id") return id_community_invite_success_request(inputs)
	if (locale === "it") return it_community_invite_success_request(inputs)
	if (locale === "ru") return ru_community_invite_success_request(inputs)
	if (locale === "pt") return pt_community_invite_success_request(inputs)
	return ko_community_invite_success_request(inputs)
});